import { render, staticRenderFns } from "./DateRangePicker.vue?vue&type=template&id=531150a6&lang=pug&"
import script from "./DateRangePicker.vue?vue&type=script&lang=js&"
export * from "./DateRangePicker.vue?vue&type=script&lang=js&"
import style0 from "./DateRangePicker.vue?vue&type=style&index=0&id=531150a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports